import React from "react";
import { FlatButton } from "material-ui";

import BaseOverlay from "./base.jsx";
import InjectedSelect from "../injected-select.jsx";
import { makeEventDateRangeLabel } from "../../../util.js";
import UserStore from "../../../stores/UserStore";

const styles = {
  container: {
    marginTop: "1em"
  },
  selectContainer: {
    marginTop: "1em"
  }
};

class ExchangeOverlay extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      ticketBucket: null,
      seatSelectionEventId: null,
      newSeats: {}
    };

    this.exchange = this.exchange.bind(this);
  }

  _getTicketCount(bucket) {
    return bucket.unlimited
      ? "unlimited"
      : Math.max(bucket.quantity_remaining, 0);
  }

  _canUseTicket(bucket) {
    if (!bucket.lock_admin_only || UserStore.hasRole("admin")) return true;

    const requiredRoles =
      (bucket.lock_admin_only_role && bucket.lock_admin_only_role.split(",")) ||
      [];

    return UserStore.hasRole(requiredRoles);
  }

  exchange() {
    this.props.onExchange(this.state.ticketBucket, this.state.newSeats);
  }

  render() {
    const { submitting, tickets, eventBucketId, onClose } = this.props;
    const { ticketBucket } = this.state;
    const ticketsLength = tickets.length;

    return (
      <BaseOverlay
        onRequestClose={onClose}
        hideTitleAndFooterBorders={true}
        showCloseButton={true}
        useMuiDefaultStyle={true}
        disableBackgroundDismiss
        actions={[
          <FlatButton label="Cancel" onClick={onClose} />,
          <FlatButton
            primary={true}
            label="Exchange"
            disabled={
              submitting ||
              !ticketBucket ||
              (this.state.seatSelectionEventId &&
                Object.values(this.state.newSeats).filter(s => !!s).length !==
                  ticketsLength)
            }
            label={submitting ? "Exchanging..." : "Exchange"}
            onClick={this.exchange}
          />
        ]}
      >
        <h2>
          Exchange {ticketsLength} ticket{ticketsLength !== 1 ? "s" : ""}
        </h2>
        <div style={styles.container}>
          Select a new ticket bucket to exchange the ticket
          {ticketsLength !== 1 ? "s" : ""}. The customer will not be charged. A
          confirmation email will be sent to the customer.
        </div>
        <div style={styles.selectContainer}>
          <InjectedSelect
            value={this.state.ticketBucket}
            type="ticket_buckets"
            eventBucketId={eventBucketId}
            placeholder="Select ticket bucket"
            labelFormatter={b => {
              let count = this._getTicketCount(b);

              return (
                <div>
                  <div>
                    {
                      count === 0
                        ? "[SOLD OUT] "
                        : ""
                    }
                    <strong>
                      {b.event.name} – {b.name}
                    </strong>
                  </div>
                  <div>{makeEventDateRangeLabel(b.event)}</div>
                  <div>{b.event.venue ? b.event.venue.name : null}</div>
                </div>
              )
            }}
            labelToFilterString={b => `${b.event.name} - ${b.name}`}
            changeValueFunction={o => o}
            onChange={selected => {
              this.setState({ ticketBucket: selected ? selected.id : null });

              const needsSeatSelection = !!(
                selected &&
                selected.event.venue &&
                selected.event.venue.use_reserved_seating
              );
              if (needsSeatSelection) {
                this.setState(
                  { seatSelectionEventId: selected.event.id },
                  () => {
                    this.chart = new seatsio.SeatingChart({
                      divId: "seatingChart",
                      workspaceKey: process.env.SEATS_IO_PUBLIC_KEY,
                      event: selected.event.id,
                      onObjectSelected: object => {
                        const updated = { ...this.state.newSeats };

                        // If one of the seats is deselected, set it first
                        for (const ticket of tickets) {
                          if (!updated[ticket.id]) {
                            updated[ticket.id] = object.label;
                            this.setState({ newSeats: updated });
                            return;
                          }
                        }

                        // Otherwise, just replace the first object
                        const previous = updated[tickets[0].id];
                        updated[tickets[0].id] = object.label;
                        this.chart.deselectObjects([previous]);
                        this.setState({ newSeats: updated });
                      },
                      onObjectDeselected: object => {
                        const updated = { ...this.state.newSeats };
                        Object.keys(updated).forEach(id => {
                          if (updated[id] === object.label) {
                            delete updated[id];
                          }
                        });
                        this.setState({ newSeats: updated });
                      }
                    }).render();
                  }
                );
              } else {
                this.setState({ seatSelectionEventId: null });
              }
            }}
            isDisabledFunction={bucket =>
              this._getTicketCount(bucket) === 0 || !this._canUseTicket(bucket)
            }
          />
        </div>
        {this.state.seatSelectionEventId ? (
          <div>
            <div style={styles.selectContainer}>
              <div id="seatingChart" style={{ height: 400 }} />
            </div>
            <div style={styles.selectContainer}>
              When you click Exchange, the following exchanges will be applied
              and the customer will receive updated tickets via email:
            </div>
            <div style={{ textAlign: "center", marginTop: "1em" }}>
              {tickets.map((t, i) => {
                return (
                  <div
                    style={{
                      marginTop: "0.25em",
                      fontWeight: "bold",
                      fontSize: "1.25em"
                    }}
                  >
                    Ticket #{i + 1} ({t.seat || "No seat"}) →{" "}
                    {this.state.newSeats[t.id] || "Not yet selected"}
                  </div>
                );
              })}
            </div>
          </div>
        ) : null}
      </BaseOverlay>
    );
  }
}

export default ExchangeOverlay;



// WEBPACK FOOTER //
// ./src/app/components/partials/overlays/exchange-overlay.jsx